import { InjectionToken } from '@angular/core';

/**
 * Overlay tint colors as `r,g,b` triplets — they are composed into `rgba(r,g,b,opacity)`
 * at swipe time, so CSS custom properties cannot be used here. Fairs needing different
 * verdict colors provide their own SW_SWIPE_CARD_DEFAULT_OPTIONS.
 */
export class SWSwipeCardConfig {
  likeColor?: string = '104,159,56';

  dislikeColor?: string = '193,3,2';
}

export function swSwipeCardDefaultOptionsFactory() {
  return new SWSwipeCardConfig();
}

export const SW_SWIPE_CARD_DEFAULT_OPTIONS = new InjectionToken('sw-swipe-card-default-options', {
  providedIn: 'root',
  factory: swSwipeCardDefaultOptionsFactory,
});
